module.exports = __webpack_public_path__ + "static/assets/c104645acd3a9f1102e49f91e8950216.png";